import { circleVsCircle } from '../engine/collision.js';

export function updateAmmoPickups(game, dt) {
  const player = game.player;
  if (!player?.alive) return;
  for (let i = game.ammoPickups.length - 1; i >= 0; i--) {
    const p = game.ammoPickups[i];
    p.t += dt;
    p.mesh.rotation.y += dt * 2.8;
    p.mesh.position.y = 0.28 + Math.sin(p.t * 5) * 0.06;
    const d = Math.hypot(player.x - p.x, player.z - p.z);
    if (d <= player.radius + p.radius) {
      const gained = player.addReserveAmmo(p.amount);
      if (gained > 0) {
        game.audio.play('itemPickup', { rate: 1.08 + Math.random() * 0.06 });
        game.toast(`+${gained} AMMO`);
      }
      game._dropHoverMeta.delete(p.mesh);
      game.scene.remove(p.mesh);
      game.ammoPickups.splice(i, 1);
    }
  }
}

export function smartEquipFromPickup(game, weaponId) {
  if (game.player.tryAutoEquipWeapon(weaponId)) return true;
  return game.player.swapHandWeapon('right', weaponId);
}

export function updateWeaponPickups(game, dt) {
  const player = game.player;
  if (!player?.alive) return;
  const hasLegacyWeaponPickups = game.weaponPickups.length > 0;
  const equipPressed = hasLegacyWeaponPickups
    ? (game.input.consumeEquipPressed?.()
      || game.input.consumeKey('KeyE')
      || game.input.consumeKey('KeyF'))
    : false;
  for (let i = game.weaponPickups.length - 1; i >= 0; i--) {
    const p = game.weaponPickups[i];
    p.t += dt;
    p.mesh.rotation.y += dt * 2.2;
    p.mesh.position.y = 0.42 + Math.sin(p.t * 4.1) * 0.08;
    const d = Math.hypot(player.x - p.x, player.z - p.z);
    if (d > player.radius + p.radius) continue;
    let equipped = player.tryAutoEquipWeapon(p.weaponId);
    if (!equipped && equipPressed) {
      equipped = smartEquipFromPickup(game, p.weaponId);
    } else if (!equipped && !player.swapHintShown) {
      player.swapHintShown = true;
      game.toast('PRESS E OR F TO EQUIP');
    }
    if (!equipped) continue;
    game.audio.play('itemPickup', { rate: 1.03 + Math.random() * 0.06 });
    game.toast(`${p.weaponName.toUpperCase()} EQUIPPED`);
    game._dropHoverMeta.delete(p.mesh);
    game.scene.remove(p.mesh);
    game.weaponPickups.splice(i, 1);
  }
}

export function explodePlayerProjectile(game, p, x, z) {
  const radius = p.explosionRadius ?? 0;
  const damage = p.explosionDamage ?? p.damage;
  if (radius <= 0 || damage <= 0) return;
  for (const enemy of game.enemies) {
    if (!enemy?.alive) continue;
    const d = Math.hypot(enemy.x - x, enemy.z - z);
    if (d <= radius + enemy.radius) {
      enemy.queueHitDirection?.(p.dx, p.dz);
      enemy.takeDamage(damage, game);
    }
  }
  if (p.clusterCount > 0) {
    for (let i = 0; i < p.clusterCount; i++) {
      const angle = (i / p.clusterCount) * Math.PI * 2;
      const dx = Math.cos(angle);
      const dz = Math.sin(angle);
      game.spawnPlayerProjectile(x, z, dx, dz, {
        speed: 17 + game.rng() * 6,
        damage: damage * 0.45,
        life: 0.45 + game.rng() * 0.22,
      });
    }
  }
  game._flashCircle(x, z, radius);
  game.audio.play('explode', { pitchJitter: 0.08 });
  game.cameraRig.shake(0.32);
}

export function updatePlayerMines(game, dt) {
  for (let i = game.playerMines.length - 1; i >= 0; i--) {
    const mine = game.playerMines[i];
    mine.t += dt;
    mine.life -= dt;
    mine.mesh.rotation.y += dt * 3.1;
    const pulse = 0.9 + Math.sin(mine.t * 8) * 0.1;
    mine.mesh.scale.setScalar(pulse);
    let explode = mine.life <= 0;
    if (!explode && mine.t >= mine.armedAt) {
      for (const enemy of game.enemies) {
        if (!enemy?.alive) continue;
        if (circleVsCircle(mine.x, mine.z, mine.triggerRadius, enemy.x, enemy.z, enemy.radius)) {
          explode = true;
          break;
        }
      }
    }
    if (!explode) continue;
    for (const enemy of game.enemies) {
      if (!enemy?.alive) continue;
      const d = Math.hypot(enemy.x - mine.x, enemy.z - mine.z);
      if (d <= mine.radius + enemy.radius) enemy.takeDamage(mine.damage, game);
    }
    game._flashCircle(mine.x, mine.z, mine.radius);
    game.audio.play('explode', { pitchJitter: 0.1 });
    game.scene.remove(mine.mesh);
    game.playerMines.splice(i, 1);
  }
}
